import { allRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { communicationActivityPageActions } from "./communicationActivityPageActions";
import { communicationActivityPageConfig } from "./communicationActivityPageConfig";
import { communicationActivityPageBadges } from "./communicationActivityPageBadges";
import {
  adaptCommunicationActivityRecord,
  CommunicationActivitySendDateField,
} from "./communicationActivityRecordAdapter";

export const communicationActivityRecordDefinition: RecordDefinition = {
  path: "/communication-activity",
  actions: communicationActivityPageActions,
  entityName: "g4c_communicationactivity",
  listRoute: "/communication-activities",
  backTitle: "Back to communication activities",
  allowedRoles: allRoles,
  // A record of a send, written by the service, so nobody edits it here.
  recordEditRoles: [],
  config: communicationActivityPageConfig,
  recordAdapter: adaptCommunicationActivityRecord,
  identity: {
    titleFields: ["g4c_recipientemailaddress"],
    subtitleField: CommunicationActivitySendDateField,
    fallbackTitle: "Communication Activity",
    newRecordTitle: "New Communication Activity",
  },
  badges: communicationActivityPageBadges,
};
